// third-party
import { configureStore } from "@reduxjs/toolkit";

// project import
import reducers from "./reducers";

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const store = configureStore({
  reducer: reducers,
});

const { dispatch } = store;

export { dispatch, store };

export type AppDispatch = typeof dispatch;
export type RootState = ReturnType<typeof store.getState>;
